import { cardsReducer } from '@/features/cards/cardsReducer';
import { configurationReducer } from '@/features/configuration/configurationReducer';
import { loadingReducer } from '@/features/loading/loadingReducer';
import { manageReducer } from '@/features/manage/manageReducer';
import { mapComponentReducer } from '@/features/map-component/mapComponentReducer';
import { profileReducer } from '@/features/profile/profileReducer';
import { purchaseReducer } from '@/features/purchase/purchaseReducer';
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { createFilter } from 'redux-persist-transform-filter';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  purchase: purchaseReducer,
  loading: loadingReducer,
  configuration: configurationReducer,
  cards: cardsReducer,
  manage: manageReducer,
  profile: profileReducer,
  mapComponent: mapComponentReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const persistedReducer = persistReducer<RootState>(
  {
    key: 'root',
    storage,
    whitelist: ['purchase', 'manage'],
    transforms: [
      // Purchase: the in-progress booking id (refetched on load) plus the
      // started exchange operation, so change-booking checkout can resolve
      // its operation after a refresh.
      createFilter('purchase', ['booking.id', 'exchangeOperation']),
      // Manage: the booking being modified + the change-trips selection,
      // so a refresh mid-change-booking-checkout keeps the flow alive
      // (otherwise `hasSelection`/`useCheckoutBooking` reset and the user
      // is bounced out of checkout).
      createFilter('manage', ['booking', 'changeTrips']),
    ],
    stateReconciler: autoMergeLevel2,
  },
  rootReducer
);
